module.exports = __webpack_public_path__ + "img/20200507_135953.fb12bc07.jpg";